export default __webpack_public_path__ + "static/radler_badge-fe14242863dccdd816087320dcf5c3b3.svg";